export default "__VITE_ASSET__Cnanh4k1__"